// Copyright (c) 2022 WiseTime. All rights reserved.

import React from "react"
import TimeBlockRow from "./TimeBlockRow"
import { getDescription } from "../timeRows"
import { TimeBlockRowsWrapper } from "../../shared/styles"
import { PostStatus, TimeRow } from "../../../generated/wisetime/user/timeline/v4/timeline_pb"
import { HexColor } from "../color"
import { recordedTime, timeRowIdsWithDivider } from "../timesheet/timeRows"

type Props = {
  timeRows: TimeRow.AsObject[],
  activeTimeRowsIds?: string[],
  isActive?: boolean,
  timeGroupPostStatus?: PostStatus,
  rangeSelector?: (clickedRowId: string) => string[],
  timeGroupColor?: HexColor,
  className?: string,
}

const TimeBlockRows = ({
  timeRows,
  activeTimeRowsIds = [],
  isActive,
  timeGroupPostStatus,
  rangeSelector,
  timeGroupColor,
  className,
}: Props) => (
  <TimeBlockRowsWrapper className={className}>
    {timeRows.map(timeRow => {
      const hourDividerColor = timeGroupColor && timeRowIdsWithDivider(timeRows).includes(timeRow.id)
        ? timeGroupColor : undefined
      return (
        <TimeBlockRow
          key={timeRow.id}
          timeRowId={timeRow.id}
          timeGroupId={timeRow.timeGroupId}
          tagsList={timeRow.tagsList}
          tagSuggestionsList={timeRow.tagSuggestionsList}
          activityTypesList={timeRow.activityTypesList}
          tagCategoriesList={timeRow.tagCategoriesList}
          activity={timeRow.activity}
          description={getDescription(timeRow.description)}
          iconUrl={timeRow.iconUrl}
          duration={timeRow.duration?.seconds}
          trashStatus={timeRow.trashStatus}
          timeGroupPostStatus={timeGroupPostStatus}
          isActive={isActive !== undefined ? isActive : activeTimeRowsIds.includes(timeRow.id)}
          formattedTime={timeRow.timeGroupId !== "" ? recordedTime(timeRow) : undefined}
          hourDividerColor={hourDividerColor}
          rangeSelector={rangeSelector}
        />
      )
    })}
  </TimeBlockRowsWrapper>
)

export default TimeBlockRows
